import { formatTempWithAlt } from '../../lib/instructions';

// The read-only rendering of a method — temperatures then steps. Shared by
// the methods library, the formula page and the batch sheet, so those three
// can't drift into showing the same method three different ways.
export default function MethodBody({ method, temperaturesOnly = false }) {
  const temps = (method?.temperatures || []).filter((t) => t && t.label && t.low != null);
  const steps = method?.steps || [];

  if (!temps.length && !steps.length) return null;

  return (
    <>
      {temps.length > 0 && (
        <ul className="method-temps">
          {temps.map((t, i) => (
            <li key={`${t.label}-${i}`}>
              <span>{t.label}</span>
              <strong>{formatTempWithAlt({ label: t.label, value: t.low, max: t.high, unit: t.unit })}</strong>
            </li>
          ))}
        </ul>
      )}
      {!temperaturesOnly && steps.length > 0 && (
        <ol className="method-steps">
          {steps.map((step, i) => (
            <li key={i}>{step}</li>
          ))}
        </ol>
      )}
    </>
  );
}
